// OTP entry for CRM 2.0 confirmations (M3-F1 server OTP): "Send OTP" → digits → Confirm.
// send() must resolve { challengeId, digits, maskedMobile, resendAfterSeconds };
// verify(challengeId, code) must resolve on success (the server checks the code, the portal never sees it).
import React, { useEffect, useRef, useState } from "react";
import { errorTost } from "../../../Services/Toast";
import css from "./Crm2Booking.module.css";

export default function OtpEntry({ send, verify, sendLabel = "Send OTP", confirmLabel = "Confirm", disabled, onVerified, who }) {
	const [ch, setCh] = useState(null);
	const [code, setCode] = useState("");
	const [busy, setBusy] = useState(false);
	const [wait, setWait] = useState(0);
	const [note, setNote] = useState("");
	const timer = useRef(null);

	useEffect(() => () => clearInterval(timer.current), []);
	const startWait = (s) => {
		clearInterval(timer.current);
		setWait(s);
		timer.current = setInterval(() => setWait((w) => (w <= 1 ? (clearInterval(timer.current), 0) : w - 1)), 1000);
	};

	const doSend = () => {
		setBusy(true);
		setNote("");
		send()
			.then((data) => {
				setCh(data);
				setCode("");
				startWait(Number(data?.resendAfterSeconds) || 30);
				console.log("[crm2][otp] sent", { to: data?.maskedMobile });
			})
			.catch((err) => {
				if (err.retryAfterSeconds) startWait(err.retryAfterSeconds);
				errorTost(err.message);
			})
			.finally(() => setBusy(false));
	};

	const doVerify = () => {
		setBusy(true);
		verify(ch.challengeId, code)
			.then((data) => onVerified && onVerified(data))
			.catch((err) => {
				setCode("");
				if (err.status === 423 || err.status === 410 || err.status === 409) setCh(null);
				setNote(err.message);
			})
			.finally(() => setBusy(false));
	};

	if (!ch) {
		return (
			<div className={css.otpRow}>
				{note && <div className={css.otpNote}>{note}</div>}
				<button type="button" className={`${css.btn} ${css.btnP}`} disabled={disabled || busy || wait > 0} onClick={doSend}>
					{busy ? "Sending…" : wait > 0 ? `${sendLabel} (${wait}s)` : sendLabel}
				</button>
			</div>
		);
	}
	const digits = Number(ch.digits) || 6;
	return (
		<div className={css.otpBox}>
			<div className={css.otpTo}>
				OTP sent to {who ? <b>{who}</b> : null} {ch.maskedMobile}
			</div>
			<input
				className={css.otpInput}
				inputMode="numeric"
				autoComplete="one-time-code"
				maxLength={digits}
				value={code}
				placeholder={"•".repeat(digits)}
				onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, digits))}
				aria-label="OTP"
			/>
			{note && <div className={css.otpNote}>{note}</div>}
			<div className={css.otpActs}>
				<button type="button" className={`${css.btn} ${css.btnP}`} disabled={busy || code.length !== digits} onClick={doVerify}>
					{busy ? "Checking…" : confirmLabel}
				</button>
				<span className={css.lk} onClick={() => wait === 0 && !busy && doSend()} style={wait > 0 ? { opacity: 0.5, cursor: "default" } : null}>
					{wait > 0 ? `Resend OTP in ${wait}s` : "Resend OTP"}
				</span>
			</div>
		</div>
	);
}
